import Call from "../../service/axios";
import {getUrl} from "../../constants/urls";
import {trackPromise} from "react-promise-tracker";
import CallV2 from "../../service/axiosV2";

export const fetchOrganizationDetails = () => trackPromise(Call.get(getUrl("org")));

export const fetchOrganizationImages = () => trackPromise(CallV2.get(getUrl("branding")));

export const saveOrganizationImagesAsync = (data) => {
  const url = getUrl("branding");
  return trackPromise(
    CallV2.post(url, data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
  );
};
